import { Trans, useTranslation } from 'react-i18next';
import { replaceFsCount } from '@/modules/promo';
import { ScOfferWithLine } from './styled';

interface IOfferWithLineProps {
  translation: string;
  fsCount?: number;
}

export const OfferWithLine = ({
  translation,
  fsCount,
}: IOfferWithLineProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation(translation);
  return (
    <ScOfferWithLine>
      <h1 className="title">{t('titleLine.first')}</h1>
      <p className={`description-first ${language.toLowerCase()}`}>
        <Trans
          components={{ 1: <span className="bonus__text-fs" /> }}
          i18nKey="deskLine.first"
          ns={translation}
        />
      </p>
      <div className="line" />
      <h1 className="title">{t('titleLine.second')}</h1>
      <h2 className={`description-second ${language.toLowerCase()}`}>
        {replaceFsCount(t('deskLine.second', { fs: fsCount }), fsCount)}
      </h2>
    </ScOfferWithLine>
  );
};
